// import React from "react";
// import Common_Heading from "../../common-components/common-heading/Common_Heading";
// import "./Why_Choose_Dream11.css";

// const reasonsData = [
//   {
//     icon: "🔒",
//     iconAlt: "Encrypted",
//     title: "Encrypted",
//     subtitle: "Secure Transactions",
//     description:
//       "Industry leading encryption for all your financial data and seamless instant withdrawals anytime.",
//   },
//   {
//     icon: "✅",
//     iconAlt: "Certified",
//     title: "Certified",
//     subtitle: "Fair Play Guaranteed",
//     description:
//       "Certified system ensures total transparency and equal winning opportunities in every single contest.",
//   },
//   {
//     icon: "🎧",
//     iconAlt: "Always Active",
//     title: "Always Active",
//     subtitle: "24/7 Support",
//     description:
//       "Our dedicated team is always here to help you with any queries, ensuring your experience remain smooth.",
//   },
// ];

// function WhyChooseDream11() {
//   return (
//     <section className="why-choose-section">
//       <div className="container text-center">
//         <div className="why-choose-heading">
//           {/* <Common_Heading head1="Why Choose 11Dream" /> */}
//           <Common_Heading
//             head1={
//               <>
//                 Why Choose 11<span>Dream?</span>
//               </>
//             }
//           />
//         </div>
//         <div className="row justify-content-center mt-4">
//           {reasonsData.map(
//             ({ icon, iconAlt, title, subtitle, description }, idx) => (
//               <div key={idx} className="col-lg-4 col-md-6 mb-4">
//                 <div className="reason-card">
//                   <div className="reason-icon" aria-label={iconAlt} role="img">
//                     <span>{icon}</span>
//                   </div>
//                   <h5 className="reason-title">{title}</h5>
//                   <h6 className="reason-subtitle">{subtitle}</h6>
//                   <p className="reason-description">{description}</p>
//                 </div>
//               </div>
//             ),
//           )}
//         </div>
//       </div>
//     </section>
//   );
// }

// export default WhyChooseDream11;

import React from "react";
import Common_Heading from "../../common-components/common-heading/Common_Heading";
import "./Why_Choose_Dream11.css";

const reasonsData = [
  {
    imgSrc: "/assets/images/about-us/secure-transaction.png",
    logoSrc: "/assets/images/Glyph.png",
    imgAlt: "Encrypted",
    title: "Encrypted",
    subtitle: "Secure Transactions",
    description:
      "Industry leading encryption for all your financial data and seamless instant withdrawals anytime.",
  },
  {
    imgSrc: "/assets/images/about-us/fair-play.png",
    logoSrc: "/assets/images/certified.png",
    imgAlt: "Certified",
    title: "Certified",
    subtitle: "Fair Play Guaranteed",
    description:
      "Certified system ensures total transparency and equal winning opportunities in every single contest.",
  },
  {
    imgSrc: "/assets/images/about-us/always-active.png",
    logoSrc: "/assets/images/customer-support.png",
    imgAlt: "Always Active",
    title: "Always Active",
    subtitle: "24/7 Support",
    description:
      "Our dedicated team is always here to help you with any queries, ensuring your experience remain smooth.",
  },
];

function WhyChooseDream11() {
  return (
    <section className="why-choose-section">
      <div className="container text-center">
        <div className="why-choose-heading">
          <Common_Heading
            head1={
              <>
                Why Choose <span1 className="highlight-number">11</span1>
                <span>DREAMS</span>?
              </>
            }
          />
        </div>
        <div className="row mt-4">
          {reasonsData.map(
            (
              { imgSrc, logoSrc, imgAlt, title, subtitle, description },
              idx,
            ) => (
              <div key={idx} className="col-lg-4 col-md-6 mb-4">
                <div className="reason-card">
                  <div className="reason-card-img-container">
                    <img src={imgSrc} alt={imgAlt} className="reason-card-bg" />

                    <div className="overlay-header">
                      <img
                        src={logoSrc}
                        alt={`${title} logo`}
                        className="reason-card-logo"
                      />
                      <h5 className="reason-title">{title}</h5>
                    </div>
                  </div>

                  <div className="reason-card-text">
                    <h6 className="reason-subtitle">{subtitle}</h6>
                    <p className="reason-description">{description}</p>
                  </div>
                </div>
              </div>
            ),
          )}
        </div>
      </div>
    </section>
  );
}

export default WhyChooseDream11;
